module.exports = {
  title: "LesPark-The best APP for lesbians,queer and bisexual women",
  description: "LesPark is a global lesbian live video streaming social network.THE MOST ENJOYABLE LESBIAN APP.",
  header: {
    nav1: "Hot Live",
    nav2: "Subscription",
    nav3: "Anchor Center",
    nav3_1: "Anchor system",
    nav3_2: "Start live on PC",
    nav3_3: "Sign",
    nav3_4: "How to start live on PC",
    nav3_5: "Live",
    nav3_6: "Withdraw",
    nav4: "Service",
    nav5: "About Us",
    nav6: "Login/Register",
    me1: "Subscription",
    me2: "Log Out",
    live: "Live",
    topic: "Topic",
    baihuaTitle: "Baihua Plan",
    baihuaAward: "Subsidies",
    ContactUs: "Contact us",
    myHome: "My Home",
    jihua:"悸花乐读",
  },
  login: {
    nav1: "	Login",
    nav2: "Register",
    nav3_1: "Quick login",
    nav3_2: "Quick login without Registration",
    nav4: "Sign in directly with a third-party account",
    nav5: "Please scan the QR code",
    nav6: "to download and register LesPark",
    nav7: "or",
    nav8: "Login",
    input1: "Phone Number",
    input2: "Enter Number",
    input3: "China",
    input4: "American",
    input5: "Taiwan",
    input6: "HongKong",
    input7: "Macao",
    input8: "Thailand",
    input9: "Malaysia",
    input10: "Singapore",
    input11: "Japan",
    input12: "Korea",
    input13: "Australia",
    input14: "England",
    input15: "Philippines",
    input16: "Vietnam"
  },
  home: {
    download: "Download",
    download1: "IOS",
    download2: "Android",
    download3: "QRcode",
    liveTitle1: "Following",
    liveTitle1_1: "The host that does not have your concern temporarily is live, go to see popular live show",
    liveTitle2: "Hot Live",
    liveTitle3: "Hot Topic",
    liveTitle3_1: "no hot topic",
    appProfile: "App Profile",
    more: "More"
  },
  swiper: {
    0: {
      h1Content: "Baihua Plan",
      h2Content: "Shoot short videos to get millions of subsidies"
    },
    1: {
      h1Content: "Broadcast live",
      h2Content: "Interact with High-class anchor"
    },
    2: {
      h1Content: "Multi-video chat",
      h2Content: "Video chat and Matchmaking"
    },
    3: {
      h1Content: "People nearby",
      h2Content: "Discover the circle of friends"
    },
    4: {
      h1Content: "Loving Park",
      h2Content: "Love Record "
    },
    5: {
      h1Content: "Real-time voice chat",
      h2Content: "Sweet voice than first love"
    },
    6: {
      h1Content: "Fast Parts",
      h2Content: "Match to the soulmate ,goodbye to the single day"
    }
  },
  live: {
    nav1: "Follow",
    nav2: "Followed",
    nav3: "Hot",
    nav4: "send",
    nav5: "Loading...",
    nav6: "End Live",
    nav7: "Follow",
    nav8: "Hot"
  },
  foot: {
    // content1: '',
    // content2: ' ',
    content3: "Orient Basic Science And Technology Co., Limited  ｜ 2013-2020 All Rights Reserved  ｜ Customer service：010-56153450 ",
    // content4: '｜Email：cs@lespark.us',
    // content5: ' Links',
    // content6: ''
    content1: "Guangdong Public Network Security No. 44180202000386",
    content2: "Guangdong ICP No. 18016053",
    content4: " 举报邮箱：cs@lespark.us",
    content5: " 友情链接",
    content6: "Guangdong Wangwen (2018) No. 3153-1052",
    HelpCenter: "Help Center",
    PrivacyPolicy: "Privacy Policy",
    ServiceAgreement: "Service Agreement",
    ReportPhone: "Report Phone",
    ReportEmail: "Report Email",
    CompanyProfile: "Company Profile",
    JoinUs: "Join Us",
    contactUs: "contact Us",
    ServiceTel: "Service Tel"
  },
  foot2: {
    content3: "Orient Basic Science And Technology Co., Limited  ｜ 2016-2023 All Rights Reserved  ｜ Customer service：010-56153450 ",
    content1: "Guangxi Public Network Security No. 45050302000153",
    content2: "Guangxi ICP No. 20003447-1",
    content6:"Guangxi Wangwen（2023）No. 1925-390",
  },
  live_star: {
    pc: "Computer Live Broadcasting",
    account: "LesPark account:",
    noLogin: "Not logged in,",
    login: "Click to Login",
    liveTitle: "Live title:",
    liveCover: "Live Cover:",
    oldLiveCover: "Use the last live cover (avatar)",
    customimg: "Custom Pictures",
    plugFlow: "Push stream address:",
    copy: "copy",
    secret: "key:",
    finishLive: "End Live",
    getLiveAdd: "Get the live address",
    liveNote: "Notes:",
    liveNote1: "1. According to the relevant regulations, please complete the real name certification in the LesPark app before starting the broadcast. Please comply with",
    liveNote2: "2. Log in to the LesPark account on this page, enter the title, select the cover, and click the \"Get Broadcast Address\" button",
    liveNote3: "3. Configure the push stream address and key in the OBS, click Start to push the stream",
    liveNote4: "4. At the end of the live broadcast, please be sure to click \"End Live\" on this page, otherwise the live room will be affected by the black screen",
    convention: "LesPark Live Broadcast Convention"
  },
  mobile_login: {
    title: "Please login first~",
    sendCode: "Send",
    resendCode: "Resend",
    btnName: "Login",
    agreeLic: "Registration is deemed to agree to",
    lic: "\"LesPark Terms of Use\"",
    sendCodeFail: "Failed to send verification code",
    errPhoneFormat: "Phone format error",
    errVerifyCodeRequired: "verification code must be filled",
    errVerifyCodeFormat: "Verification code format error",
    success: "login successful",
    fail: "Login failed",
    phoneRequired: "Please enter phone number",
    verifyCodeRequired: "Enter code"
  },
  dynamic: {
    comment: "Comments",
    moreComment: "View more reviews",
    liaoXjj: "Young ladies",//Go to tease young lady
    faXianXjj: "Find more beautiful sisters",
    nodata: "The post was deleted by the publisher, go to LesPark to find more interesting posts"
  },
  video: {
    comment: "Enter comment...",
    more: "More exciting videos",
    nodata: "The short video was deleted by the publisher. Go to LesPark to post and see his other works~",
    notSupport: "This video is currently unavailable, please try again later",
    payTips:'This is a paid video, please enter the app to view it.',
  },
  profile: {
    moreFriends: "Discover more interesting friends",
    years: "years old",
    userId: "ID",
    fans: "Fan",
    girlSounds: "The girl sounds",
    chat: "Private chat",
    signature: "Personal Signature",
    fullText: "full text",
    notSupportAudio: "Your browser does not support the audio element",
    nodata: "Ah oh ~ this user account is logged out, go to LesPark to find more interesting girls"
  },
  common: {
    follow: "Follow",
    followed: "Followed",
    followFail: "Follow failed",
    goAndSeed: "Go",
    like: "Like",
    liked: "Praised",
    unlikeFail: "Cancel like failed",
    likeFail: "Like failed",
    likedUnit: " Praised"
  },
  downloadTip: {
    title: "Check out more comments at LesPark",
    textBtn: "Go to LesPark",
    video: "Check out more interesting videos on LesPark App~",
    profile: "Go to LesPark App to learn more about Miss Sister，and chat with little Sister~",
    dynamic: "Go to LesPark to find more interesting posts"
  },
  bottomBar: {
    video: "Discover more interesting short videos at LesPark",
    profile: "Discover more interesting young ladies in LesPark",
    dynamic: "Go to LesPark to find more interesting posts"
  },
  error: {
    userNotExist: "Account does not exist",
    networkException: "Network Error",
    phoneVerifyException: "Abnormal mobile number",
    paramInvalid: "Parameter error",
    verifyCodeError: "Verification code error",
    unsafeEnv: "The current use environment is risky（machine review）",
    accountRegisted: "Mobile number is registered",
    postNotFound: "Post does not exist or has been deleted",
    posterNotFound: "Poster does not exist",
    userNotFound: "Account does not exist"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-en.png",
    award: ["￥", "3", "0", "0", "0", "K"],
    bg1Tips: "Short video creation income reward",
    bg1Tips2: "Join \"Baihua Plan\" and publish original high-quality short videos to enjoy creative income",
    rule: "Rule description",
    bg2Title: "The world's largest female video platform",
    bg2Tips: ["Loads of &nbsp;", "traffic", "and &nbsp;", "profit", "await you"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-en.png",
    bg2Tips2: "Cash rewards",
    bg2Tips3: "*If \"Baihua Plan\" is successfully added to generate effective play volume, super high revenue can be obtained",
    bg3Title: "LesPark invites every creator to join Baihua Plan",
    bg3Tips: ["Each&nbsp;", "unique you&nbsp;", " will be seen"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-en.png",
    bg3Tips2: "The above is only part of the rules, please check ",
    bg3Tips3: "Please read the rules and terms carefully before joining Baihua Plan",
    bg3Tips4: "By joining the Program, you are deemed to have read, understood and agreed to all the Rules",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-en.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-en.svga",
  },
  photowall: {
    title: "Dverse women around the world",
    LaunchedYears: "Launched 7 years",
    millionsWomen: `20 millions+<br/> women users`,
    content1: `serving millions of `,
    content2: `diverse women around the world`,
    content3: `Make matches for<br/> thousands of couples`,
    content4: `1000+ <br/>dating room`
  },
  liveAll: {
    content1: "Hot live",
    content2: "All lives"
  },
  topicAll: {
    content1: "Hot topic",
    content2: "All topics",
    join: " people join"
  },
  headerOptions: [
    {
      value: "anchor",
      label: "Anchor management",
      children: [
        {
          value: "pc",
          label: "Start PC live"
        },
        // {
        //   value: 'backend',
        //   label: 'Anchor management backstage',
        // },
        {
          value: "invite",
          label: "Recruit quality anchors"
        },
        {
          value: "sign",
          label: "input signing info."
        }
        // {
        //   value: 'withdraw',
        //   label: 'withdraw',
        // },
      ]
    },
    {
      value: "union",
      label: "GUild",
      children: [
        {
          value: "Trade",
          label: "Guild enters"
        },
        {
          value: "management",
          label: "GUild management backstage"
        }
      ]
    }
  ],
  lesApp: {
    content1: "LesPark - Meet over 20 million women",
    content2: " comments",
    content3: "It is a social platform for thousands of women to record and share their lives,express themselves easily through live broadcast and voice chat,share thousands of fresh videos,voice,text and pics everyday,discover the real and interesting world and let them making friends easily.  ",
    content4: "LesPark mission:To connect women around the world and make a tolerant and happy place.",
    content5: "Brodcast live",
    content6: "High-class anchor will chat and sing with you here",
    content7: "Multi-video chat",
    content8: "Matchmaker online,multiplayer mode,let you find the right person",
    content9: "people nearby",
    content10: "Through the accurate location to find nearby lesbians,let you GET her",
    content11: "Video matching",
    content12: "one-on-one video matching chat,real person video,no pretence,face to face hot chat,get to know each other",
    content13: "Loving Park",
    content14: "Lesbian lovers'exclusive space,recording every moment of love;Complete the couple list and daily clocking tasks,and get points to redeem gifts.",
    content15: "Voice party",
    content16: "Live online voice party,chat,sing,date,play games with beauties,take you away from loneliness.",
    content17: "Real-time voice chat",
    content18: "10s to match the distance of her,speak freely with strangers,make new friends,tell stories,say good night,find a nice voice and let the voice heal you.",
    content19: "Fast Parts",
    content20: "Make friends out of single, the single to be rescued,according to your preferences and location setting,quickly match interests of her.",
    content21: "Users reviews",
    content22: "Rating from 29820 users",
    content23: "Q&A",
    content24: "Will there be any male users in the APP？",
    content25: "No,we have an audit customer service team to strictly audit online 7*24 hours a day.Male users are not allowed to enter.Once found,they will be banned.",
    content26: "Why LesPark?",
    content27: "LesPark is an exclusive lesbian social app that creats a safe apce for women.The gole is to provide a platform for friendly relationships and dialogue without bullying,prejudice,judgement and social risk. ",
    content28: "Does LesPark charge?",
    content29: "LesPark is a free social APP that can be downloaded from the APP Store and Android APP Store.  ",
    content30: "Will LesPark reveal anything about me?",
    content31: "LesPark will not disclose user information to third parties in any way to ensure your privacy and security.",
    commentList: [
      {
        time: "2021-06-28",
        name: "Kim L ",
        content: "Very good App!!! I like and enjoying my time on this site. It has created an opportunity for me to meet and communicate with likeminded people."
      },
      {
        time: "2021-08-01",
        name: "Montoya Byrd",
        content: `Ilike lespark! Personally, I think it's better to use a good-looking lesbian dating app. Watching the live broadcast is also very happy, can meet like-minded friend`
      },
      {
        time: "2021-08-01",
        name: "schultewinforda",
        content: "lesbians app. With this software, it provides us with an interactive dating platform, and I also find my true love. Thank you so much!"
      },
      {
        time: "2021-08-13",
        name: "Jessia edwardo",
        content: "Great application ! Good comment. I hope I can find a handsome date in it "
      },
      {
        time: "2021-09-01",
        name: "Sirena Betancourt ",
        content: `Continue to use~  You can see the dynamic life of different people, participate in different topics to understand everyone's opinion`
      }
    ]
  },
  aboutUs: {
    content1: `LesPark is a mobile social application for global female friends-making by Qingyuan Park Culture Media Co.Ltd., Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.`,
    content1_1: `LesPark is a mobile social application for global female friends-making by Park Culture Media Co.,Ltd; Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.`,
    content1_2: `LesPark is a mobile social application for global female friends-making by ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.`,
    content2: `Here you can show yourself through community or live broadcast, and interact with fans in real-time. Join nearby groups to participate in various activites according to the location,establish a good and health social relations with nearby people as well.`,
    content3: `“Live for Love” has always been LesPark's slogan, aiming to creat platform for women to record and share their lives.`,
    content4: `At present, LesPark has been online for 7 years, with more than 20 million vertical users in 34 countries around the world, and more than 150,000 anchors.`,
    content5: `Corporate Culture`,
    content6: `Mission`,
    content7: `Connecting with minorities around the world,making the world more tolerant and happier`,
    content8: ``,
    content9: `Vision`,
    content10: `Become the most reliable global company for minority groups`,
    content11: `Build an universal value network for minority groups through continuous innovation `,
    content12: ``,
    content13: `Values`,
    content14: `User first, team collaboration`,
    content15: `Results-oriented, pursuit for perfection`,
    content16: `Be proactive and fearless`,
    content17: `Join us`,
    content18: `We need talents in product, operation, technology and other positions,looking forward to your participation!`,
    content19: `Join now`,
    content20: `contact us`,
    content21: `Contacts`,
    content22: `Mr. Zhang`,
    content23: `Service Tel`,
    content24: `Address: `,
    content25: `Report complaints`,
    content26: `No. 08 office, 14th Floor, Yunshan Shiyi Building, Rd 88 Guangqing Avenue, Qingyuan city, Guangdong province`,
    content26_1: `No. 0401, Building 1, Suifeng Jinwan, No. 299 Sichuan Road, Beihai City, Guangxi Zhuang Autonomous Region`,
    content26_2: `ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD.`,
  },
  loginHome: {
    content1: "加载更多",
    content2: "粉丝",
    content3: "获赞",
    content4: "动态"
  },
  topicItem: {
    content1: "人赞",
    content2: "查看全部",
    content3: "条评论",
    content4: "回复",
    content5: "评论...",
    content6: "发送"
  },
  baihuaRule: {
    title: "Rules of Baihua Plan",
    ruleSet: [
      `Before joining the Baihua Plan (hereinafter referred to as "the plan"), please read the rules and related terms in detail. Any application to join the Baihua Plan is deemed to have read, understand, and agree to the entire content of the rules.`,
      `<h3 class="h3-label">Plan introduction</h3>`,
      `The Baihua Plan is an activity of incentive short video creation organized by the LesPark. The author who successfully joined the Baihua Plan,<span> through the original high -definition video (duration ≥10 seconds)</span> released in the app, has the opportunity to enjoy creative income.`,
      `<h3 class="h3-label">How to join the plan</h3>`,
      `1. You can apply for the Baihua Plan by clicking the "Join" button on the program introduction page and completing the corresponding requirements tasks.`,
      `2. Before applying for the Baihua plan, the following application tasks need to be completed. LesPark will review the video content quality of applicants based on the rules of the plan.`,
      `1)Complete the mobile phone number binding and real-name authentication<br/>
2)In the past 30 days, it has released no less than 5 publicly visible, original high-definition videos (definition ≥ 720P and duration ≥ 10 seconds) through LesPark App<br/>
3)In the past 30 days, the total view of all publicly visible and original high-definition videos (duration ≥ 10 seconds) released through LesPark App has reached 60,000
`,
      `When you complete the application task, you can click the button to submit the review. Official staff will determine whether you can join the plan according to the original high-definition video (duration ≥10 seconds) released by the account and content quality standards (see rules for details: <a href="/baihuaQualityReview.html">content quality review</a>), etc. The result of the review will be announced through the plan introduction page and message notification.`,
      `1) If the review is not passed due to non-compliance with the content quality standards and other reasons, you can adjust according to the corresponding reasons or suggestions, or try to publish at least 5 original high-definition videos (duration ≥ 10 seconds) again. After the adjustment, you can resubmit the review application.<br/>
2) The platform gives priority to encouraging creators who independently shoot and create to join the program.<br/>
3) The current account is not an abnormal state such as cancellation, deletion, and banning.<br/>
4) The created video shall meet the original standard of the platform (see the rule for details: <a href="/baihuaOriginalStandards.html">original standards</a>), and there shall be no pornographic, vulgar, unclear picture, increasing video playback through cheating and other adverse problems. It does not involve such negative guidance issues as minors, advertising and marketing, illegal teaching, speech attacks, and unqualified financial explanation. At the same time, note that if a large number of videos are meaningless in the account or simple processing based on a certain material, and the lowest level of creativity, the applicant cannot join the Baihua Plan.
      `,
      `<h3 class="h3-label">income of the plan</h3>`,
      `1. Video creation income<br/>
After successfully joining the program, if video playback volume of the original high-definition video (duration ≥ 10 seconds) released through LesPark App reaches 20,000,  and if the video passes the content quality review and are in the "revenue review " state, the revenue playback of the video can obtain creative revenue. Note: The revenue period of a single video work is within 90 days after it is released and passed review, and if it exceeds 90 days, it will be set as "Expired"; If the video work fails to pass the review, it will be set as "Failed"; If the review is passed and the period does not exceed 90 days, it will be set to "Profitable" status.<br/>
2. Income viewing and withdrawal<br/>
1) The income obtained after joining the Baihua Plan can be viewed in the LesPark App - My - Sidebar - Creator Center, or in the LesPark App - My - Sidebar - Diamond Wallet.<br/>
2) The withdrawal of income can be applied for at most once a day. You can select the amount and platform of the corresponding gear according to the withdrawal amount, and submit the withdrawal application. After the withdrawal is approved, the corresponding payment will be made.`,
      `<h3 class="h3-label">Description of violation</h3>`,
      `1. LesPark officials have the right to conduct security verification for users participating in this activity<br/>
If the users participating in this activity have or have ever violated laws and regulations or LesPark App rules or the principle of good faith, LesPark officials have the right to take measures, including but not limited to restricting the registration/login to LesPark App, prohibiting participation in this activity, revoking the qualification to participate in the activity, revoking or freezing the qualification to obtain income from the activity (including but not limited to virtual goods, cash, physical benefits, etc. that may be obtained through participating in the activity), inability to obtain or can only obtain part of the activity proceeds, full/partial restrictions on the use/withdrawal of the obtained activity proceeds, withdrawal of the released activity proceeds, closure of the account, etc., and reserve the right to pursue the relevant legal liabilities of the user.
The behaviors violating the principle of good faith include but are not limited to:<br/>
1) Download the unofficial client;<br/>
2)Use the mobile phone number, virtual mobile phone number, QQ, WeChat and other third-party platform accounts suspected of high-risk cheating to register/log in to LesPark App;<br/>
3)Modify page parameters and tamper with device data;<br/>
4)Participate in the activities with any robotic software, spider software, crawler software, screen flooding software or any non-artificial way;<br/>
5)Using illegal tools such as simulator, plug-in, APP avatars and other illegal tools to scan, download, install, register, log in to LesPark clients, participate in activities, receive activity income, withdraw, and donate activity income to others;<br/>
6)Disturb the platform order through malicious profit-making means;<br/>
7)Use plug-ins, group control systems or third-party tools to interfere, destroy, modify or exert other influences on the LesPark platform and this activity;<br/>
8)Colluding with other users or using machines to cheat, skim the proceeds of activities and other activities that disrupt the order of activities;<br/>
9)Other behaviors against the principle of good faith that LesPark platform has reasonable grounds to suspect.<br/>
<br/>
2.In the process of participating in this activity, if the user makes any profit or illegal profit with the activity reward obtained, trades or transfers the reward obtained through the activity in any form, or the LesPark official has reasonable grounds to suspect that the user improperly uses the activity reward to disturb the order of the LesPark App, LesPark officials have the right to disqualify users from participating in activities, withdraw the issued activity rewards (including those used and unused), and reserve the right to investigate the relevant legal liabilities of users.
<br/><br/>
3.The LesPark official specially reminds you that you must participate in this activity through the LesPark official and LesPark official designated path. LesPark will not bear any legal responsibility for user losses caused by users' participation in any non LesPark official activities or activities conducted under the name of LesPark.
`,
      `<h3 class="h3-label">matters needing attention</h3>`,
      `1.According to relevant laws and regulations, if the sponsor needs to withhold and remit individual income tax on the income of the winners under this activity, the sponsor has the right to withhold and remit according to law. Without the prior written permission of the organizer, the rights or rewards obtained by users for participating in this activity shall not be transferred.<br/>
2.Users shall not participate in this activity by any improper means or fraud or use this activity to engage in illegal acts. Once found, LesPark has the right to take measures such as reducing the activity reward, restricting withdrawal, clearing the account amount, revoking the activity qualification, restricting login, banning the account, restricting re registration and use, and also has the right to recover the reward received by the user, recover the amount withdrawn, and reserve the right to investigate the responsibility of the user.<br/>
3.The sponsor operates the event according to law. If the event is adjusted, suspended, unable to be held, or the user fails to participate due to force majeure, changes in circumstances, changes in relevant policies, requirements of government authorities, insufficient number of participants, third party reasons and other non sponsor reasons, the sponsor has the right to decide to modify, suspend, cancel or terminate the event at any time, without any legal liability. If the participation fails due to the user's own reasons, the adverse consequences shall be borne by the user. The user can view the modified activity rules at any time on this page. If the user has any objection to the modified activity rules, please stop participating. If the user continues to participate in the activity, it is deemed that the user agrees to the modification of the activity rules.<br/>
4.The LesPark Terms of Use and the LesPark Privacy Policy are also applicable to this event. If the rules and relevant provisions of this event conflict with the LesPark Terms of Use and the LesPark Privacy Policy, the rules and relevant provisions of this event shall prevail. The contents not stipulated in the rules and relevant provisions of this activity are still subject to the LesPark Terms of Use and the LesPark Privacy Policy.<br/>
5.If you encounter any problems during the activity, you can open the LesPark App and consult through manual customer service or contact the official WeChat account.<br/>
6.Apple Inc. is not a sponsor or involved in this activity in any manner.<br/>
`
    ]
  },
  baihuaOriginalStandards: {
    title: "Baihua Plan Original Standard Instructions",
    ruleSet: [
      `<div class="h3-label">Definition of original work</div>`,
      `1.Live shooting: Individual or team independently created videos, and owns the relevant copyright of all contents in the works<br/>
(1) The video content picture is clean and tidy, the theme is clear, the content is complete and has memory points, and the account content style is unified;<br/>
(2) Real person videos should have clear human attributes. The real name authentication information of the presenter and the account should be consistent;<br/>
(3) Videos that are not real people appearing on the camera should have a clear theme orientation, and the content under the account can be judged to belong to the current account creation according to the vertical category, style, account characteristics, and materials provided by the author;
`,
      `2.Secondary editing works<br/>
(1) On the basis of moderately quoting the original video materials, create a new video work with rich information, own editing ideas and originality for the second time;<br/>
(2) The secondary creation forms include but are not limited to commentary, editing, special effects packaging, audio processing, etc. that reflect author's own ideas and thoughts;
`,
      `3. The following types are not original works<br/>
(1) Upload works similar to others:<br/>
● Upload and publish other people's works directly by transporting, screen recording, and screen shooting;<br/>
● Publish (or directly upload) copyrighted content such as film and television plays, variety shows, anime, music videos, news, games and sports events without the authorization of the copyright owner or without copyright<br/>
● Pure screen recording content, recording and broadcasting works that the creator did not participate in filming, recording, and processing`,
      `(2)Content with a low level of secondary creation<br/>
● Low content richness, such as simple editing and splicing of original materials, or simple addition of short opening remarks, scene transition words, background music, etc.<br/>
● The cost of secondary creation is relatively low, and only simple translation of video materials or copy, and the video dubbing is stiff and rigid; Or use other people's audio works, simply with video images<br/>
● Narrow interpretation information, no clear theme and output of personal effective information values. The commentary copy in the video is suspected of plagiarism, and the opinions come from the Internet<br/>
● The quoted materials are of low quality, such as fuzzy jitter, stretch amplification/reduction, and obvious black edges, etc. in the quoted video and image materials<br/>
● The reference material is less relevant to the theme of the video`,
      `(3)Post more than once<br/>
● The same video is published in different accounts of the author or the company, and all claim to be original<br/>
● Within the same account, the same video is repeatedly declared to be original, which can be exempted under special circumstances, such as: the first release is wrong but it is quickly deleted, and the content is continued to be improved and processed on the basis of the first release<br/>`,
      `(4)Works that cannot prove originality:<br/>
● The account publishes atlas works, and the originality cannot be proved: the account publishes low-quality picture works, such as text information screenshots, empty and meaningless snapshots, sentimental sentences, classic quotations, etc.; the account releases obvious network pictures, such as celebrities, beauties, and online influencer introductions, etc.
`]
  },
  baihuaQualityReview: {
    title: "Content Quality Review Rules",
    ruleSet: [
      `<div class="h3-label">Ⅰ. High-quality original author</div>`,
      `1. Have stable production capacity and continuously and steadily update works in LesPark<br/>
2. The works produced by the author are vertical in field, uniform in style and with personal characteristics<br/>
3. The author insists on producing original works, respecting creation and copyright<br/>
4. The author continues to produce high-quality works, bringing users a good viewing experience
`,
      `<div class="h3-label">Ⅱ. High-quality works</div>`,
      `1. Good viewing experience<br/>
(1) High quality works:<br/>
● Cover: The covers have a strong sense of visual impact, unified style, and highlight the key points, which helps users to form a series of perceptions in terms of look and feel<br/>
● Title: The title is intuitive and prominent, relevant to the content, and there are no problems such as exaggeration of the title<br/>
● Picture: The video picture is beautiful and clear, without noise, and with appropriate contrast; the video picture is complete, without excessive watermarks, upscaling, enlargement and cropping resulting in incomplete picture, black borders and other problems<br/>
● Sound: The audio and picture of video are synchronized without noise, and the characters' lines have clear sound and appropriate volume<br/>
● Subtitles: The video subtitles are completely visible, and the subtitles are synchronized with the video picture and video sound<br/>
● Rhythm: The video is smooth, playing is not stuck, and the plot is complete<br/>
(2) The work meets one of the characteristics of timeliness, professionalism, practicality, and interest, etc.<br/>
(3) The idea of the work is complete, the expression theme is clear and definite, and the overall perception of the work is comfortable, pleasant, and ornamental.<br/>
2. High cost of works creation<br/>
(1) Early stage of production: The work has a complete idea, and the shooting process includes scripts, plots, copywriting design, actors, etc.<br/>
(2) Later stage of production: improve the viewability of the video by adding subtitles, background music, etc., with smooth video clips and high video integrity`,
      `<div class="h3-label">Ⅲ. Non-quality works</div>`,
      `(1) Simple and rough fabrication:<br/>
● Casually photographed in daily life with empty content/no specific practical meaning/casually photographed/no viewing value/lack of visibility<br/>
● Live broadcast preview, live broadcast screen recording and other contents without reprocessing, and the content is thin and the picture is single<br/>
● Network picture patchwork atlas<br/>
(2) Discomfortable video appearance:<br/>
● Video brings people a serious image impact and discomfort, such as bloody and dense images<br/>
(3) Bad values:<br/>
● Videos promote bad ethos and inappropriate behaviors, such as money worship, miserable sales, uncivilized words, fights, etc.<br/>
(4) Marketing promotion/inducing likes:<br/>
● Pure advertising for profit, guiding users to trade offline<br/>
● Malicious cheating behavior of soliciting favor and attention through emotional kidnapping<br/>
(5) Rumor and pseudoscience<br/>
● Disseminate unconfirmed false information, feudal superstition and content contrary to scientific laws
`
    ]
  },
  mobleTxt:{
    t1:'Anchor Recruitment',
    download:'Download',
    download2:'Download',
    more:'More',
    lesAppTitle:'- Meet over 20 million women',
    aboutUsT1:'Live for Love',
  },
};



// WEBPACK FOOTER //
// ./static/js/en.js